<template>
  <section class="section container pt-0">
    <verification-requests-datatable />
  </section>
</template>

<script>
import VerificationRequestsDatatable from "./verification_requests_datatable/Index.vue";

export default {
  name: "RenapVerification",
  components: {
    VerificationRequestsDatatable,
  },
  data() {
    return {};
  },
  methods: {
    retrieve_settings() {
      // get_configuration(this)
      //   .then((conf) => {
      //     console.log("configuration retrieved", conf);
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //   });
    },
    create() {
      console.log("create order");
    },
    refresh() {
      console.log("refresh orders");
    },
  },
  mounted() {},
  created() {},
};
</script>

<style scoped></style>
